import {ASSIGNEE, CHANGE_ASSGINEE, ASSGINEE_ACCOUNT, DEALER_LISTING_ASSIGNEE, REASSIGN_DEALER_MANAGER} from "./type";

const initialState = {
    getAssignee:[],
    ChangeAssignee:[],
    accountAssigneedetails:[],
    getDealerListingForAssignee:[],
    reassignDealerWithManager:[]
};

const AssignmentReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case ASSIGNEE:
            return {
                ...state,
                getAssignee: payload,
            };
        case CHANGE_ASSGINEE:
            return {
                ...state,
                ChangeAssignee: payload,
            };
        case ASSGINEE_ACCOUNT:
            return {
                ...state,
                accountAssigneedetails: payload,
            };
        case DEALER_LISTING_ASSIGNEE:
            return {
                ...state,
                getDealerListingForAssignee: payload,
            };
        case REASSIGN_DEALER_MANAGER:
            return {
                ...state,
                reassignDealerWithManager: payload,
            };
        default:
            return {...state};
    }
};

export default AssignmentReducer;